import { AppMode } from ".";
import { BackOfficeLinks } from "./links/BackOfficeLinks";
import { CustomerLinks } from "./links/CustomerLinks";
import Divider from "components/Divider";
import { Link } from "react-router-dom";
import { MenuItem } from "react-pro-sidebar";
import { getIsAuthenticated } from "atoms/auth";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import useUserInfo from "hooks/useUserInfo";

interface NavigationItemProps {
  appMode: AppMode;
}

export const NavigationItems = ({ appMode }: NavigationItemProps) => {
  const { userEmail } = useUserInfo();
  const isAuthenticated = useRecoilValue(getIsAuthenticated);
  const { t } = useTranslation();

  return (
    <>
      {appMode === "Back Office" ? <BackOfficeLinks /> : <CustomerLinks />}

      <Divider margin="16px 0 24px 0" dark />

      <MenuItem
        active={false}
        icon={<i className="uil uil-question-circle is-size-4" />}
        className="sidebar-top-menu-item"
        component={
          <a
            rel="noopener noreferrer"
            href="https://help.adfenix.com"
            target="_blank"
            data-loglabel="help-adfenix-link"
          />
        }
      >
        Help center
      </MenuItem>

      {isAuthenticated && userEmail !== "logs@adfenix.com" && (
        <MenuItem
          icon={<i className="uil uil-exit is-size-4" />}
          className="sidebar-top-menu-item"
          component={<Link to={"/auth/logout"} />}
        >
          {t("listings.heading.logout")}
        </MenuItem>
      )}
    </>
  );
};
